import * as React from 'react';
import { lazyInject } from '../../../services/inversify';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { IDs } from '../../../helpers/IDs';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';

interface UnternehmenProps extends React.ClassAttributes<any> {
    data: any;
    standortSelected: any;
}

interface UnternehmenState {
    dummy?: any;
}

export class Unternehmen extends React.Component<UnternehmenProps, UnternehmenState> {

    constructor(props: any) {
        super(props);
        this.state = {
        };
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    render(): JSX.Element {

        const customFormatter = (key: string, value: any, data: any, row: any) => {
            if (value === undefined || value === null) {
                return '';
            }
            return value;
        };

        // const customColumns: Array<any> = [{
        //     accessor: 'berater',
        //     Header: 'Berater',
        //     id: 'berater',
        //     type: 'text'
        // }];

        return (
            <div>
                <WFormsTableWrapper
                    entity={IDs.ENT_UNTERNEHMEN}
                    module={IDs.MOD_ETOOL_ADMIN}
                    data={this.props.data[IDs.ENT_UNTERNEHMEN]}
                    actions={['add', 'edit', 'delete']}
                    customClass={'Custom-ETA'}
                    customFormatter={customFormatter}
                    formLayout={'flowV2'}
                    showColumnsHelp={true}
                    // customColumns={customColumns}
                    onAfterAction={(action: string) => {
                        if (action === 'saveDone' || action === 'delDone') {
                            this.triggerService.fire('admin_reload', IDs.ENT_UNTERNEHMEN);
                        }
                    }}
                />
            </div>
        );
    }
}
